import { WSIcons } from "../../../commonFunctions/iIcons";

export const menuConfig = [
  {
    id: 101,
    label: "Invoice",
    icon: WSIcons.Print,
    path: "/",
    featureKey: "invoice",
    roles: ["admin", "accountant"]
  },
  {
    id: 102,
    label: "Invoice List",
    icon: WSIcons.OverViewIcon,
    path: "/invoice/list",
    featureKey: "invoice",
    roles: ["admin", "accountant"]
  },
  {
    id: 105,
    label: "Product List",
    icon: WSIcons.ShoppingBagIcon,
    path: "/products/list",
    featureKey: "product",
    roles: ["admin", "accountant"]
  },
  {
    id: 106,
    label: "Category",
    icon: WSIcons.Category,
    path: "/category/list",
    featureKey: "category",
    roles: ["admin", "accountant"]
  },
  {
    id: 109,
    label: "Purchase & Expense",
    icon: WSIcons.Money,
    roles: ["admin", "accountant"],
    children: [
      {
        id: 110,
        label: "Purchase",
        path: "/purchase/list",
        featureKey: "purchase"
      },
      {
        id: 111,
        label: "Payment Out",
        path: "/payment-out/list",
        featureKey: "payment_out"
      },
      {
        id: 112,
        label: "Expense",
        path: "/expense/list",
        featureKey: "expense"
      }
    ]
  },
  {
    id: 115,
    label: "Cash & Bank",
    icon: WSIcons.ShakeHands,
    roles: ["admin", "accountant"],
    children: [
      {
        id: 116,
        label: "Bank Accounts",
        path: "/Bank-account/list",
        featureKey: "bank_account"
      },
      {
        id: 117,
        label: "Cash In Hand",
        path: "/cash-in-hand/list",
        featureKey: "cash"
      },
      {
        id: 118,
        label: "Loan Accounts",
        path: "/loan-account/list",
        featureKey: "loan"
      }
    ]
  },
  {
    id: 103,
    label: "Vendor",
    icon: WSIcons.Store,
    path: "/party/list",
    featureKey: "vendor",
    roles: ["admin"]
  },
  {
    id: 121,
    label: "Customer",
    icon: WSIcons.Person,
    path: "/customer/list",
    roles: ["admin", "accountant"]
  },
  {
    id: 120,
    label: "Shipping",
    icon: WSIcons.Shipping,
    path: "/shipping/list",
    featureKey: "shipping",
    roles: ["admin", "accountant"]
  },
  {
    id: 104,
    label: "Reports",
    icon: WSIcons.reportIcon,
    path: "/reports",
    featureKey: "reports",
    roles: ["admin"]
  },
  {
    id: 119,
    label: "Users",
    icon: WSIcons.UserGroup,
    path: "/user/list",
    featureKey: "users",
    roles: ["admin"]
  }
];